export default __webpack_public_path__ + "static/media/icon-user.6b97d066.svg";